export enum ECompanyModality {
  ORDERSHEET = 'orderSheet',
  REMOVAL_ITEM = 'removalItem',
  DELIVERY = 'delivery',
}



export default ECompanyModality;
